import React, {Component, Fragment} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import SearchField from "./SearchField.js";
import FormControl from "@material-ui/core/FormControl";
import withWidth from '@material-ui/core/withWidth';
import Collapse from '@material-ui/core/Collapse';
import compose from 'recompose/compose';
import Hidden from '@material-ui/core/Hidden';
import {Settings} from "../Utils/Settings";

const styles = theme => ({
    formControl: {
        width: "100%",
    }
});

class SearchFields extends Component {

    constructor(props, context) {
        super(props, context);
        // Empty defaults for everything
        this.state = {
            expandSearchButtonClicked: false
        }
    }
    onFormSubmit = e => {
        // Prevent the form from actually submitting
        e.preventDefault();
        this.setState({
            expandSearchButtonClicked: false,
        });
        this.props.handleSearch(1);
    }

    onExpandButtonPressed = (e) => {
        //e.currentTarget.style.display="none";
        this.setState({
            expandSearchButtonClicked: true,
        });
    }

    render() {
        const {classes,
            handleSearch,
            handleSearchFieldChange,
            handleSortFieldChange,
            searchFields,
            searchFieldsError,
            width
        } = this.props;

        const { expandSearchButtonClicked } = this.state;

        var isExpanded = (width != "xs") || expandSearchButtonClicked;
        let errorMessage = (searchFieldsError) ?
            <Typography variant='body2' align='center'>Error: {searchFieldsError.message}</Typography> :
            null;

        let sortFields = searchFields.fields.some(x => x.sortable) ?
            <Grid item xs={12}>
                <Typography variant='body1'>
                    Sort by:<br/>
                    {
                        searchFields.fields.filter(x => x.sortable && !x.hideField).map((element, index) => {
                            let buttonStyle = (element.isBeingSorted) ? "primary" : "default";
                            return (
                                <Button key={index} style={{margin: "5px"}} onClick={() => {
                                    handleSortFieldChange(element.filterId)
                                }} variant="contained" size="small"
                                        color={buttonStyle}>{element.label}</Button>
                            )
                        })
                    }
                </Typography>
            </Grid> :
            null;

        let resetButton = (Settings.showResetButton) ?
            <Button variant="contained" size="large" color="primary" onClick={()=>{window.location = window.location.pathname}}>Reset</Button> :
            <Fragment></Fragment>;

        if (searchFields.fields) {
            return (
                <Paper style={{padding: "10px"}}>
                    {errorMessage}
                    <form onSubmit={this.onFormSubmit}>
                        <Typography display={{ xs: 'block', md: 'none' }} variant='h5' align='center'>{searchFields.categoryName}</Typography>
                        <Collapse in={!isExpanded}><Hidden smUp><Button variant="contained" size="small" display={{xs: "block", sm: "none"}} onClick={this.onExpandButtonPressed}>Search 🞂</Button></Hidden></Collapse>
                        <Collapse in={isExpanded}>
                            <Grid container spacing={24}>
                                {
                                    searchFields.fields.filter(x => (!x.hideField && x.fieldType != "sortonly")).map((element, index) => {
                                        return (
                                            <Grid key={index} item md={3} sm={4} xs={12}>
                                                <SearchField classes={classes} field={element}
                                                             handleSearchFieldChange={handleSearchFieldChange}></SearchField>
                                            </Grid>
                                        );
                                    })
                                }
                                <Grid item xs={12}>
                                    <Button type={"submit"} variant="contained" size="large" color="primary" style={{marginRight: "10px"}}>Search</Button>
                                    {resetButton}

                                </Grid>
                                {sortFields}
                            </Grid>
                        </Collapse>
                    </form>
                </Paper>);
        }
        return ("");
    }
}
export default compose(
    withStyles(styles),
    withWidth()
)(SearchFields);

